import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../../contexts/AuthContext'
import { useFetch } from '../../useFetch'

import { CONFIG } from '../../../config'
import { ApiError } from '../../../types/exception/errorStatus'
import { getErrorMessage } from '../../../utils/exception/exceptionUtils'

export const useOpenGate = () => {
  const { t } = useTranslation('exceptions')
  const { authInfo } = useAuth()
  const { poster } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const openGate = async () => {
    setLoading(true)
    setError(null)

    try {
      return await poster<boolean>(
        `${CONFIG.BOUNCE_API}/api/v1/widgets/gate`,
        undefined,
        'application/json'
      )
    } catch (caughtError) {
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
      return null
    } finally {
      setLoading(false)
    }
  }

  return { openGate, loading, error }
}
